import { apiOpenDelivery } from "@/api";
import { validateObject } from "@/lib";
import { getStoredCompany } from "@/lib/company-storage";
import { ApiData } from "@/types";
import axios, { AxiosResponse } from "axios";

let catalogWindow: string | null = null;

/**
 * Target window (`targetWindow.startsAt`) the menu must be filtered by while
 * the store is closed and the channel still takes scheduled orders (D16).
 * `null` restores the catalog of right now. Returns true when it changed.
 */
export function setCatalogWindow(startsAt: string | null): boolean {
  if (catalogWindow === startsAt) return false;
  catalogWindow = startsAt;
  return true;
}

/** The window the catalog is currently being requested with. */
export function getCatalogWindow(): string | null {
  return catalogWindow;
}

export default async function fetchApi(): Promise<ApiData | null> {
  const company = getStoredCompany();
  if (!company) return null;

  try {
    const res: AxiosResponse<ApiData> = await apiOpenDelivery.get(`/${company.id}`, {
      params: catalogWindow ? { window: catalogWindow } : undefined,
    });

    const normalizedData: ApiData = {
      ...res.data,
      availabilities: res.data.availabilities ?? [],
      items: res.data.items ?? [],
      categories: res.data.categories ?? [],
      itemOffers: res.data.itemOffers ?? [],
      optionGroups: res.data.optionGroups ?? [],
    };

    if (
      !validateObject(normalizedData, [
        "basicInfo",
        "services",
        "menus",
      ])
    )
      throw new Error();

    return normalizedData;
  } catch (err) {
    if (axios.isAxiosError(err)) throw err;
    else throw new Error("Something is wrong", { cause: err });
  }
}
